<template>
  <div class="page-wrapper">
    <!-- ====================== PC 端 ====================== -->
    <div class="pc-version">
      <div
        class="api-log-table-container"
        v-loading="loading"
        element-loading-text="加载中..."
      >
        <!-- 搜索栏 -->
        <div
          class="search-bar"
          style="
            margin-bottom: 20px;
            display: flex;
            gap: 10px;
            align-items: center;
            flex-wrap: wrap;
          "
        >
          <el-input
            v-model="searchParams.user_id"
            placeholder="请输入用户ID"
            clearable
            style="width: 200px"
          ></el-input>

          <el-button type="primary" @click="getList">搜索</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </div>

        <!-- 表格 -->
        <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%"
          @row-click="handleRowClick"
        >
          <el-table-column label="ID" prop="id" width="80" align="center" />
          <el-table-column
            label="用户ID"
            prop="user_id"
            width="120"
            align="center"
          />
          <el-table-column label="请求地址" prop="url" min-width="240" />
          <el-table-column label="状态" width="100" align="center">
            <template slot-scope="scope">
              <span
                :style="{
                  color: scope.row.status == 1 ? '#67c23a' : '#f56c6c',
                  fontWeight: 'bold',
                }"
              >
                {{ scope.row.status == 1 ? "成功" : "失败" }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="返回信息" prop="result_msg" width="140" align="center" />
          <el-table-column label="创建时间" prop="created_at" width="180" />
        </el-table>

        <!-- 分页 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>

        <!-- 详情弹窗 -->
        <el-dialog
          title="API请求详情"
          :visible.sync="detailVisible"
          width="700px"
          append-to-body
        >
          <el-form :model="detailForm" label-width="120px" size="small">
            <el-form-item label="记录ID"
              ><span>{{ detailForm.id }}</span></el-form-item
            >
            <el-form-item label="用户ID"
              ><span>{{ detailForm.user_id }}</span></el-form-item
            >
            <el-form-item label="请求地址"
              ><span>{{ detailForm.url }}</span></el-form-item
            >
            <el-form-item label="请求状态">
              <span
                :style="{
                  color: detailForm.status == 1 ? '#67c23a' : '#f56c6c',
                  fontWeight: 'bold',
                }"
              >
                {{ detailForm.status == 1 ? "成功" : "失败" }}
              </span>
            </el-form-item>
            <el-form-item label="返回信息"
              ><span>{{ detailForm.result_msg || "-" }}</span></el-form-item
            >
            <el-form-item label="请求参数">
              <pre style="margin:0; white-space: pre-wrap; word-break: break-all;">{{ detailForm.params || "无" }}</pre>
            </el-form-item>
            <el-form-item label="创建时间"
              ><span>{{ detailForm.created_at }}</span></el-form-item
            >
            <el-form-item label="更新时间"
              ><span>{{ detailForm.updated_at }}</span></el-form-item
            >
          </el-form>
          <div slot="footer" style="text-align: right">
            <el-button @click="detailVisible = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- ====================== 移动端 ====================== -->
    <div class="mobile-version">
      <div
        class="mobile-log-container"
        v-loading="loading"
        element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0,0,0,0.4)"
      >
        <!-- 搜索栏 -->
        <div class="mobile-search-group">
          <el-input
            v-model="searchParams.user_id"
            placeholder="用户ID"
            clearable
            size="medium"
            prefix-icon="el-icon-user"
          />

          <div style="display: flex; gap: 8px; margin-top: 10px">
            <el-button
              type="primary"
              plain
              round
              @click="getList"
              style="flex: 1"
              >搜索</el-button
            >
            <el-button plain round @click="resetSearch" style="flex: 1"
              >重置</el-button
            >
          </div>
        </div>

        <!-- 卡片列表 -->
        <div class="mobile-card-list">
          <div
            class="mobile-card"
            v-for="item in tableData"
            :key="item.id"
            @click="openMobileDetail(item)"
          >
            <div class="card-top">
              <div class="id-info">
                <span>ID：{{ item.id }}</span>
                <span class="type-tag" :class="item.status == 1 ? 'success' : 'fail'">
                  {{ item.status == 1 ? "成功" : "失败" }}
                </span>
              </div>
            </div>

            <div class="card-middle">
              <div>用户ID：{{ item.user_id }}</div>
              <div class="url-text">地址：{{ item.url }}</div>
              <div>结果：{{ item.result_msg }}</div>
            </div>

            <div class="card-bottom">
              <div class="time">{{ item.created_at }}</div>
            </div>
          </div>
        </div>

        <!-- 分页 -->
        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="total, prev, pager, next, jumper"
            :total="total"
            pager-count="2"
            small
          />
        </div>

        <!-- 移动端详情弹窗 -->
        <el-dialog
          title="API请求详情"
          :visible.sync="mobileDetailVisible"
          width="95%"
          top="8vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <el-form
            v-if="mobileDetailRow"
            :model="mobileDetailRow"
            label-width="100px"
            size="small"
          >
            <el-form-item label="记录ID">{{ mobileDetailRow.id }}</el-form-item>
            <el-form-item label="用户ID">{{ mobileDetailRow.user_id }}</el-form-item>
            <el-form-item label="请求地址">{{ mobileDetailRow.url }}</el-form-item>
            <el-form-item label="请求状态">
              <span
                :style="{
                  color: mobileDetailRow.status == 1 ? '#67c23a' : '#f56c6c',
                  fontWeight: 'bold',
                }"
              >
                {{ mobileDetailRow.status == 1 ? "成功" : "失败" }}
              </span>
            </el-form-item>
            <el-form-item label="返回信息">{{ mobileDetailRow.result_msg || "-" }}</el-form-item>
            <el-form-item label="请求参数">
              <pre style="margin:0; white-space: pre-wrap; word-break: break-all;">{{ mobileDetailRow.params || "无" }}</pre>
            </el-form-item>
            <el-form-item label="创建时间">{{ mobileDetailRow.created_at }}</el-form-item>
            <el-form-item label="更新时间">{{ mobileDetailRow.updated_at }}</el-form-item>
          </el-form>

          <div slot="footer" style="text-align: right">
            <el-button @click="mobileDetailVisible = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";

export default {
  name: "UserApiRequestLogList",
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      searchParams: {
        page: 1,
        page_size: 10,
        user_id: "",
      },
      // PC
      detailVisible: false,
      detailForm: {},
      // 移动端
      mobileDetailVisible: false,
      mobileDetailRow: null,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      this.loading = true;
      try {
        const res = await api.logs.userApiRequestLog({
          params: this.searchParams,
        });
        if (res.data.code == 1000) {
          this.tableData = res.data.data.data;
          this.total = res.data.data.total;
        }
      } finally {
        this.loading = false;
      }
    },

    handleRowClick(row) {
      this.detailForm = { ...row };
      this.detailVisible = true;
    },

    openMobileDetail(row) {
      this.mobileDetailRow = JSON.parse(JSON.stringify(row));
      this.mobileDetailVisible = true;
    },

    resetSearch() {
      this.searchParams = {
        page: 1,
        page_size: 10,
        user_id: "",
      };
      this.getList();
    },

    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getList();
    },
  },
};
</script>

<style scoped>
/* ====================== PC 原有样式 ====================== */
.api-log-table-container {
  padding: 20px;
}

/* ====================== 移动端样式 ====================== */
.mobile-log-container {
  padding: 12px;
  box-sizing: border-box;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.id-info {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}
.type-tag {
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  color: #fff;
}
.type-tag.success {
  background: #67c23a;
}
.type-tag.fail {
  background: #f56c6c;
}
.url-text {
  word-break: break-all;
  margin: 4px 0;
}
.card-middle {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 8px;
}
.card-bottom {
  font-size: 12px;
  color: #999;
  line-height: 1.5;
  padding-top: 8px;
  border-top: 1px dashed #f0f0f0;
}
</style>


// WEBPACK FOOTER //
// src/pages/log/api_request.vue